import { PAGE_LIMIT } from "../constants/pagination";

export function readPagination(res) {
  const top = res?.pagination && typeof res.pagination === "object" ? res.pagination : {};
  const nestedData = res?.data && !Array.isArray(res.data) ? res.data : {};
  const nested = nestedData.pagination && typeof nestedData.pagination === "object"
    ? nestedData.pagination
    : {};

  const page = Number(top.page || nested.page || nestedData.page || 1) || 1;
  const limit = Number(top.limit || nested.limit || nestedData.limit || PAGE_LIMIT) || PAGE_LIMIT;
  const total = Number(top.total ?? nested.total ?? nestedData.total ?? 0) || 0;
  const totalPages =
    Number(top.totalPages || nested.totalPages || 0) ||
    (limit > 0 ? Math.ceil(total / limit) : 0);

  return {
    page,
    limit,
    total,
    totalPages,
    hasNextPage: Boolean(top.hasNextPage ?? nested.hasNextPage ?? page < totalPages),
    hasPreviousPage: Boolean(top.hasPreviousPage ?? nested.hasPreviousPage ?? page > 1),
  };
}

export function readListItems(res, keys = ["items", "records", "users", "banks", "entries"]) {
  if (Array.isArray(res?.data)) return res.data;
  const data = res?.data;
  if (data && typeof data === "object") {
    for (const key of keys) {
      if (Array.isArray(data[key])) return data[key];
    }
  }
  if (Array.isArray(res?.items)) return res.items;
  if (Array.isArray(res?.users)) return res.users;
  return [];
}
